import { http, HttpResponse } from 'msw'

import type { DistributionChannelId } from '@/@types/distribution-channel-id'

interface MockUpdateDistributionsPathParams {
  alphaId: string
}

interface MockUpdateDistributionsBody {
  distributionChannelId: DistributionChannelId
  data: {
    nationalContent?: boolean
    internationalContent?: boolean
    pms?: {
      pmsId: string
      code: string
    }[]
    code?: string
    login?: string
    password?: string
  }
}

export const mockUpdateDistributions = http.post<
  MockUpdateDistributionsPathParams,
  MockUpdateDistributionsBody
>('/my-business/api/agency/v1/*/:alphaId/distributions/', () => {
  return HttpResponse.json(null, { status: 201 })
})
